import React from "react";
import ReactDOM from "react-dom";
import CurrentWeather from "./CurrentWeather";
import Footer from "./Footer";

import "./App.css";

export default function App() {
  return (
    <div className="App">
      <CurrentWeather defaultCity="London" />
      <Footer />
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
